import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { RootState } from "../store";
import api from "src/utils/axios";

interface loginResponse {
  accessToken?: string;
  refreshToken?: string;
  userReturn?: any;
}

const initialState: loginResponse = {};

interface validEmailResponse {
  msg: string;
}

interface validCodeResponse {
  _id: string;
  email: string;
  status: string;
  codeAccess: string;
  __v: number;
}

const authLogin: any = createAsyncThunk<
  loginResponse,
  { email: string; password: string }
>("auth/authLogin", async ({ email, password }) => {
  const response = await api.post("/auth/login", { email, password, web: 'true' });
  const data = await response.data;
  return data;
});

const validEmail: any = createAsyncThunk<validEmailResponse, { email: string }>(
  "auth/validEmail",
  async ({ email }) => {
    const response = await api.post("/user/validEmail", { email });
    const data = await response.data;
    return data;
  }
);

const validCode: any = createAsyncThunk<
  validCodeResponse,
  { email: string; codeAccess: string }
>("auth/validCode", async ({ email, codeAccess }) => {
  const response = await api.post("/user/validCode", { email, codeAccess });
  const data = await response.data;
  return data;
});

const register: any = createAsyncThunk<
  validCodeResponse,
  { name: string; birthday: string; password: string }
>("auth/register", async ({ name, birthday, password }, { getState }) => {
  const idRegister = (getState() as RootState).auth.idRegister;
  const response = await api.put(`/user/first/${idRegister}`, {
    name,
    birthday,
    password,
  });
  const data = await response.data;
  return data;
});

const refresh: any = createAsyncThunk<
  {accessToken: string, refreshToken: string}
>("auth/refresh", async (_,{ getState }) => {
  
  const refreshToken = (getState() as RootState).auth.auth.refreshToken;
  const response = await api.post(`/auth/refresh`, {
    refreshToken
  });
  const data = await response.data;
  return data;
});

const authSlice = createSlice({
  name: "auth",
  initialState: {
    status: "idle",
    auth: initialState,
    error: undefined,
    code: null,
    idRegister: null,
  },
  reducers: {
    logout: (state, action) => {
      console.log("here logout");
      return {
        status: "idle",
        error: undefined,
        auth: {},
        code: null,
        idRegister: null,
      };
    },
    info: (state: any, action) => {
      return { ...state, auth: { ...state.auth, userReturn: action.payload } };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(authLogin.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(authLogin.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.auth = action.payload;
      })
      .addCase(authLogin.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(validEmail.pending, (state, action) => {
        state.status = "loading-validEmail";
      })
      .addCase(validEmail.fulfilled, (state, action) => {
        state.status = "succeeded-validEmail";
      })
      .addCase(validEmail.rejected, (state, action) => {
        state.status = "failed-validEmail";
      })
      .addCase(validCode.pending, (state, action) => {
        state.status = "loading-validCode";
      })
      .addCase(validCode.fulfilled, (state, action) => {
        state.status = "succeeded-validCode";
        state.idRegister = action.payload._id;
      })
      .addCase(validCode.rejected, (state, action) => {
        state.status = "failed-validCode";
      })
      .addCase(register.pending, (state, action) => {
        state.status = "loading-register";
      })
      .addCase(register.fulfilled, (state, action) => {
        state.status = "succeeded-register";
      })
      .addCase(register.rejected, (state, action) => {
        state.status = "failed-register";
      })
      .addCase(refresh.pending, (state, action) => {
        state.status = "loading-refresh";
      })
      .addCase(refresh.fulfilled, (state, action) => {
        state.status = "succeeded-refresh";
        state.auth.accessToken = action.payload.accessToken
        state.auth.refreshToken = action.payload.refreshToken
      })
      .addCase(refresh.rejected, (state, action) => {
        state.status = "failed-refresh";
      });;
  },
});

export { authLogin, validEmail, validCode, register, refresh };
export const { logout, info } = authSlice.actions;
export default authSlice.reducer;
